import classes from './Spinner.module.css';

const Spinner = () => <div className={classes.loader}/>;

export default Spinner;
